import { useEffect } from 'react';

export const useHolidayTheme = () => {
  useEffect(() => {
    const currentMonth = new Date().getMonth();
    const december = currentMonth === 11;

    const urlParams = new URLSearchParams(window.location.search);
    const holidayParam = urlParams.get('holiday');

    const explicitlyDisabled = holidayParam === 'false' || holidayParam === 'off';
    const shouldEnableHoliday =
      !explicitlyDisabled && (december || holidayParam === 'true' || urlParams.has('holiday'));

    if (!shouldEnableHoliday) {
      return () => {};
    }

    let addedScript = null;
    const existingScript = document.querySelector('script[src*="lightrope.js"]');

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/lightrope.js/lightrope.js';
      script.async = true;
      script.onerror = () => {
        // eslint-disable-next-line no-console
        console.warn('Failed to load lightrope.js');
      };
      document.body.appendChild(script);
      addedScript = script;
    }

    return () => {
      if (addedScript && addedScript.parentNode) {
        addedScript.remove();
      }
    };
  }, []);
};
